

/**
 * Dynamic API Configuration.
 * 
 * Supports environment variables injected at build time (e.g., .env / .env.production / .env.development).
 * Variables must be prefixed with `REACT_APP_` per Create React App requirements.
 *
 * Defaults:
 * - Production API: https://api.technostructacademy.com
 * - UAT API (via HTTPS Proxy): https://lms.technostructacademy.com:9696
 * - Local Dev API: http://localhost:5050
 */

const BASE_API =
  process.env.REACT_APP_API_URL || "https://api.technostructacademy.com";

export const api = process.env.REACT_APP_API_URL || BASE_API;
export const api2 = process.env.REACT_APP_API2_URL || BASE_API;
export const api_meet = process.env.REACT_APP_API_MEET_URL || BASE_API;
export const assignmentUrl = process.env.REACT_APP_ASSIGNMENT_URL || BASE_API;

export const sampleContentXls =
  process.env.REACT_APP_SAMPLE_CONTENT_XLS ||
  `${BASE_API}/static/sampleCourseExcel/course.xlsx`;


export const S3_BASE_URL = "https://technostruct-lms-01.s3.us-east-1.amazonaws.com/";

